export default "__VITE_ASSET__Czp3YM5G__"